export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask暗号通貨",
            h1B: "MetaMask暗号通貨銀行",
            h1C: "DeFiウォレット暗号通貨",
            h1D: "Coinbase暗号通貨銀行",
            h1E: "MetaMaskオンライン銀行",
            h1F: "Betterment",
            h2: "友達を招待",
            h3: "出金口座",
            h4: "貯蓄に参加",
            h4B: "デジタル通貨預金",
            h4C: "デジタル通貨チャージ",
            h5: "おすすめ投資",
            h5B: "秒契約取引",
            h5c: "利息宝（りそくほう）",
            h6: "運用データ",
            h7: "MetaMask口座",
            h8: "総産出量",
            h9: "有効ノード",
            h10: "参加者",
            h11: "収益",
            h12: "収益記録",
            h13: "アドレス",
            h14: "きんがく",
            h15: "よくある質問",
            h16: "参加するにはどうすればよいですか？",
            h17: "親愛なるユーザー様、USDTウォレット貯蓄に参加するには、プラットフォームのユーザールールを遵守し、プラットフォームの決定を厳守し、リスク部門の監督を受ける必要があります。自動的に入金権限が付与されます。ご参加を歓迎します、ありがとうございます。",
            h17B: "尊敬なるお客様へ：\nJPYCのオンライン貯蓄にご参加をご希望の場合は、プラットフォームの利用規約を遵守し、プラットフォームの関連決定を厳守するとともに、リスク管理部門の監督を受ける必要があります。条件を満たした後、自動的に貯蓄権限が付与されます。\nご参加をお待ちしております。ありがとうございます。",
            h18: "入金および出金について",
            h19: "毎日発生する収益は自動的にアカウント残高に入金され、USDT出金が成功すると自動的にUSDTウォレットアカウントに追加されます。円で出金する場合は、カスタマーサービスにお問い合わせください。ご参加とご支援ありがとうございます。",
            h19B: "貯蓄の際は、オンラインカスタマーサービスにご連絡のうえ、日本円を JPYC ステーブルコインに両替してください。両替が完了すると、JPYC は 1:1 のレートで自動的にお客様の貯蓄アカウントに追加されます。日本円を出金される場合は、銀行の出金ページにてご自身でお手続きください。",
            h20: "収入の計算方法は？",
            h21B: "普通預金の金利：\n100万 JPYC 未満：0.4％\n100万 JPYC 以上：0.5％\n300万 JPYC 以上：0.6％\n1,000万 JPYC 以上：0.8％\n2,000万 JPYC 以上：1％\n国債預金の金利：\n（数量限定販売。普通預金が 100万 JPYC 以上必要で、普通預金残高は国債に転換されます）\n15日：10％\n例：100万 JPYC の国債を購入した場合、16日目に国債残高は 110万 JPYC になります。\n1か月：25％\n例：100万 JPYC の国債を購入した場合、31日目に国債残高は 125万 JPYC になります。\n3か月：80％\n例：100万 JPYC の国債を購入した場合、91日目に国債残高は 180万 JPYC になります。",
            h21: "参加成功後、貯蓄契約が収益計算を開始します。",
            h22: "毎日の利息収益の発生時間",
            h23: "ユーザーが貯蓄に参加すると、貯蓄契約が発効します。毎日00:00、12:00の2回利息が決済されます。貯蓄契約発効後、資金は托管モードに入り、プラットフォームが資金の安全を管理します。アカウント資金の安全を確保するため、プラットフォーム規則を厳守してください。問題がある場合はオンラインカスタマーサポートに連絡してください。",
            h23B: "ユーザーが貯蓄に参加すると,貯蓄契約が有効になり,ユーザーは 00:00,06:00,12:00,18:00 の 1 日 4 回,利息の決済を受けることができます。 貯蓄契約が発効すると,ユーザーの資金は保管モードになり,プラットフォームは資金の安全性に責任を負います。 ユーザーアカウントの資金の安全を確保するために,プラットフォームのルールを厳守し,問題が発生した場合はオンラインカスタマーサービスセンターにご相談してください。",
            h24: "普通預金の利息収益",
            h25: "あなたは私のプラットフォームを友達と共有できます。友達が参加すると、初回入金額の20%の紹介報酬を得られ、さらにその収益の10%を永久に得られます。公開リンクはホームページ右上にあります。",
            h25B: "普通預金の金利：\n10万JPYC未満：0.4%\n10万 JPYC 以上：0.6％\n100万 JPYC 以上：0.8％\n300万 JPYC 以上：1.0%\n1000万 JPYC 以上：1.2％\n2000万 JPYC 以上1.5％\n5000万 JPYC 以上2.0%",
            h26: "総残高",
            h27: "利息宝の残高",
        
            h88: "プラットフォームの背景",
            h89: "Betterment\n設立年：2008年\n本社：アメリカ・ニューヨーク\nポジショニング：ロボアドバイザー（Robo-Advisor）とフィンテック（FinTech）、自動投資ポートフォリオと現金管理を提供\n監督機関：金融取引委員会（SEC）により監督、FINRAメンバー\n顧客規模：管理資産400億ドル以上\n顧客層：個人・法人合わせて80万人以上",
            h90: "プラットフォームの利点",
            h91: "✔️ アメリカ最古のRobo-Advisorで経験豊富\n✔️ 投資ポートフォリオは現代ポートフォリオ理論（MPT）に基づきリスク分散\n✔️ 税務最適化機能提供\n✔️ 高利率キャッシュアカウント、流動性が高い\n✔️ 完全デジタル操作、シンプルなインターフェイス",
            h92: "適した人々",
            h93: "★ 長期で安定した投資を望み、頻繁な操作を避けたいユーザー\n★ 自動化された資産運用で時間と手間を省きたい若年投資家\n★ 投資 + 高利率貯蓄 + 退職口座を持つ人\n★ 低コストで金融市場に参加したい一般投資家",
        
            h28: "今日の収益",
            h29: "総収益",
            h30: "出金",
            h31: "記録",
            h32: "アカウント",
            h33: "出金額",
            h34: "出金額を入力してください",
            h35: "全額",
            h36: "出金",
            h37: "よくある質問",
            h38: "セキュリティ監査報告あり",
            h39: "パートナー",
            h40: "私たちのビジネスパートナー",
            h41: "銀行カード番号を表示",
            h42: "前のページ",
            h43: "次のページ",
            h44: "既に最初のページです",
            h45: "出金額を入力してください",
            h46: "残高不足",
            h47: "既に最後のページです",
            h48: "収入",
            h49: "支出",
            h50: "操作が頻繁すぎます。後で再試行してください。",
            h51: "監査報告",
            h52: "コイン預入利息",
            h521: "預金利息",
            h53: "注文取引",
            h54: "登録ボーナス",
            h55: "招待ボーナス",
            h56: "出金",
            h57: "チャージ",
            h58: "預金",
            h59: "引き出し",
            h591: "デポジット成功",
            h592: "デポジット失敗",
            h593: "残高不足",
			h99: "近日公開",
            h60: "暗号通貨送金によるUSDTプレゼント",
            h61: "MetaMask銀行を応援していただきありがとうございます。貯蓄を便利に行うため、暗号通貨(USDT ETH BTC)で送金貯蓄すると貯蓄ボーナスを獲得できます。1000 USDT以上の貯蓄で30 USDT、5000 USDT以上で200 USDT、10000 USDT以上で毎回の金額の5%のボーナスを獲得できます。（暗号通貨ウォレットでの出金も同様の特典あり）",
            h61B: "Coinbase銀行を応援していただきありがとうございます。暗号通貨(USDT ETH BTC)で送金貯蓄すると貯蓄ボーナスを獲得できます。1000 USDT以上の貯蓄で30 USDT、5000 USDT以上で200 USDT、10000 USDT以上で毎回の金額の5%のボーナスを獲得できます。",
            h61C: "MetaMask銀行を応援していただきありがとうございます。暗号通貨(USDT ETH BTC)で送金貯蓄すると貯蓄ボーナスを獲得できます。1000 USDT以上の貯蓄で30 USDT、5000 USDT以上で200 USDT、10000 USDT以上で毎回の金額の5%のボーナスを獲得できます。",
            h61D: "Bettermentを応援していただきありがとうございます。暗号通貨(USDT ETH BTC)で送金貯蓄すると貯蓄ボーナスを獲得できます。1000 USDT以上の貯蓄で30 USDT、5000 USDT以上で200 USDT、10000 USDT以上で毎回の金額の5%のボーナスを獲得できます。",
            h62: "出金金額は{amount}、手数料は{fee}%です！",
            h63: "確認",
        },
        bankcard: {
            b1: "銀行口座",
            b2: "金融機関名",
            b3: "金融機関名を入力してください",
            b4: "支店名",
            b5: "支店名を入力してください",
            b6: "支店コード",
            b7: "支店コードを入力してください",
            b8: "口座番号",
            b9: "口座番号を入力してください",
            b10: "仮名",
            b11: "ユーザー名を入力してください",
            b12: "口座名義",
            b13: "口座名義人を入力してください",
            b14: "登録",
            b15: "メールアドレス",
            b16: "メールアドレスを入力してください",
        },
        usdt: {
            u1: "私の注文",
            u2: "入金",
            u3: "JPYC預金サイクル：",
            u4: "購入価格：",
            u5: "JPYC預入額",
            u6: "購入を増やす",
            u7: "購入を減らす",
            u8: "操作成功",
            u9: "少なくとも少し",
			u10: "国債預金の金額を入力してください",
			u11: "最低入金額 10,000"
        },
        order: {
            o0: "私の注文",
            o1: "注文番号",
            o2: "注文タイプ",
            o3: "購入金額",
            o4: "売却金額",
            o5: "支払金額",
            o6: "契約期間",
            o7: "注文ステータス",
            o8: "決済ステータス",
            o9: "決済時間",
            o10: "注文時間",
            o11: "購入を増やす",
            o12: "購入を減らす",
            o13: "売却済み",
            o14: "利益",
            o15: "損失",
            o16: "支払い済み",
            o17: "損益分岐点"
        },
        recharge: {
            r1: "チャージ金額",
            r2: "チャージ金額数",
            r3: "チャージタイプ",
            r4: "選択してください",
            r5: "チャージアドレス",
            r6: "送金取引番号",
            r7: "送金済み",
            r8: "審査中",
            r9: "入力が正しくありません",
            r10: "支払い方法を選択してください",
            r11: "最低チャージ金額は",
            r12: "チャージ上限金額は",
            r13: "金額を入力してください",
            r14: "支払いスクリーンショットをアップロード",
            r15: "支払いスクリーンショットをアップロードしてください",
            r16: "送信成功",
            r17: "キャンセル",
            r18: "確認",
        },
        rechargeDetails: {
            r1: "チャージ記録",
            r2: "チャージ金額",
            r3: "審査中",
            r4: "チャージ成功",
            r5: "チャージ失敗"
        },
		cert: {
		    c1: "本人確認",
		    c2: "本名",
		    c21: "本名を入力してください",
		    c3: "認証タイプ",
		    c31: "身分証明書",
		    c32: "パスポート",
		    c33: "運転免許証",
		    c10: "認証タイプを入力してください",
		    c4: "証明書の表面",
		    c41: "証明書の表面をアップロードしてください",
		    c5: "証明書の裏面",
		    c51: "証明書の裏面をアップロードしてください",
		    c6: "送信",
		    c7: "送信成功、審査待ち...",
		    c8: "認証に合格しました",
		    c9: "本人確認が失敗しました。再度アップロードしてください",
		    c11: "審査中",
		    "传入字段不完整": "入力項目が不完全です",
		    "已认证过": "すでに認証済みです",
		    "审核中": "審査中"
		}
		 }